import React from 'react';
import { DayHeader } from './DayHeader';
import { Consumer } from './Context';

export const WeekHeader = () => {
    const getDays = (start) => {
        const days = [];
        for (let i = 0; i < 7; i++) {
            days.push(<DayHeader key={i} weekDay={(i + start) % 7} />);
        }
        return days;
    };

    return (
        <div className="odf-calendar-row">
            <Consumer>
                {(ctx) => getDays(ctx.weekStartsOn)}
            </Consumer>
        </div>
    );
};
